import { BlacklistAPI } from "@radarly/api/blacklist";
import { PostAuthor } from "@radarly/models/posts";
import { BlacklistRepository } from "./BlacklistRepository";

interface Dependencies {
  blacklistAPI: BlacklistAPI;
}

export class ConnectedBlacklistRepository implements BlacklistRepository {
  private blacklistAPI: BlacklistAPI;
  constructor(dependencies: Dependencies) {
    this.blacklistAPI = dependencies.blacklistAPI;
  }
  public async createBlacklistAuthor(project: number, author: PostAuthor) {
    return await this.blacklistAPI.createBlacklistAuthor(project, author);
  }
}
